import React, { Fragment } from "react"
import PropTypes from "prop-types"
import Box from "../base/Box"
import Text from "../base/Text"
import Heading from "../base/Heading"
import Button from "../base/Button"
import Image from "../base/Image"
import FeatureBlock from "../FeatureBlock"
import Container from "../UI/Container"
import Particles from "../Particle"
import BannerBG from "../../assets/images/white_bg1.svg"
import BannerWrapper, { BgImageWrapper } from "./bannerSection.style"

const BannerSection = ({
  row,
  col,
  title,
  btnStyle,
  description,
  outlineBtnStyle,
}) => {
  const ButtonGroup = () => (
    <Fragment>
      <Button className="buttonContact" title="Contact Us" {...btnStyle} />
      <Button
        title="Portfolio"
        variant="textButton"
        icon={<i className="flaticon-next" />}
        {...outlineBtnStyle}
      />
    </Fragment>
  )
  return (
    <BannerWrapper id="banner_section">
      <Particles />
      <BgImageWrapper>
        {/* <Image src={BannerBG} alt='banner background' /> */}
      </BgImageWrapper>
      <Container>
        <Box className="row" {...row}>
          <Box className="col" {...col}>
            <FeatureBlock
              title={
                <Heading
                  content="Mobile & Web Development in Lausanne, Switzerland"
                  {...title}
                />
              }
              description={
                <Text
                  content="We create innovative and intuitive digital products"
                  {...description}
                />
              }
              button={<ButtonGroup />}
            />
          </Box>
        </Box>
      </Container>
    </BannerWrapper>
  )
}

BannerSection.propTypes = {
  title: PropTypes.object,
  btnStyle: PropTypes.object,
  description: PropTypes.object,
  contentStyle: PropTypes.object,
  discountText: PropTypes.object,
  discountAmount: PropTypes.object,
  outlineBtnStyle: PropTypes.object,
}

BannerSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: "wrap",
    ml: "-15px",
    mr: "-15px",
    alignItems: "center",
  },
  col: {
    pr: "15px",
    pl: "15px",
    width: ["100%", "100%", "100%", "60%", "65%"],
  },
  title: {
    fontSize: ["26px", "34px", "42px", "42px", "47px"],
    fontWeight: "700",
    color: "#fff",
    letterSpacing: "-0.025em",
    mb: ["20px", "25px"],
    lineHeight: "1.31",
  },
  description: {
    fontSize: ["14px", "16px", "18px", "18px", "20px"],
    color: "#fff",
    lineHeight: "30px",
    mb: "0",
    maxWidth: "550px",
  },
  btnStyle: {
    minWidth: ["120px", "156px"],
    fontSize: "15px",
    fontWeight: "700",
    borderRadius: "6px",
  },
  outlineBtnStyle: {
    minWidth: ["130px", "156px"],
    fontSize: "16px",
    fontWeight: "700",
    color: "#fff",
    p: "5px 10px",
  },
}

export default BannerSection
